import { render, staticRenderFns } from "./AssetLocator.vue?vue&type=template&id=66a83593&scoped=true&"
import script from "./AssetLocator.vue?vue&type=script&lang=ts&"
export * from "./AssetLocator.vue?vue&type=script&lang=ts&"
import style0 from "./AssetLocator.vue?vue&type=style&index=0&id=66a83593&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a83593",
  null
  
)

export default component.exports